/** A deterministic client error (4xx) that retrying can never resolve. */
function isClientError(error: unknown): boolean {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return typeof status === 'number' && status >= 400 && status < 500;
}

export const queryClientBaseConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 5 * 60 * 1000, // 5 minutes (reduced from 1 hour)
      cacheTime: 30 * 60 * 1000, // 30 minutes (reduced from 5 hours)
      // Don't retry 4xx: a 404/403/400 won't become a 200 by retrying, and 401
      // is already handled by the axios refresh interceptor before it surfaces
      // here. Retrying them only spams the console and delays not-found
      // redirects (e.g. opening a template you don't have access to). Network
      // and 5xx failures still get the full 3 attempts.
      retry: (failureCount: number, error: unknown) =>
        !isClientError(error) && failureCount < 3,
      retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
};
